import {
  GridColumnVisibilityModel,
  GridSortModel,
} from '@spotgamma/x-data-grid-premium';
import {
  CONTRACT_DATA_COLUMN_KEYS,
  DEFAULT_TAPE_COL_SIZES,
  DEFAULT_TAPE_COL_VISIBILITY,
  DEFAULT_TAPE_CONTRACT_COL_SIZES,
  DEFAULT_TAPE_CONTRACTS_COL_VISIBILITY,
  DEFAULT_TNS_FIELDS,
  TapeDatagridTab,
  TapeFilterTab,
} from 'config/tape';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { ScannerID } from 'types';
import {
  Filter,
  FilterConfig,
  OptionsFeedColumnKey,
  OptionsFeedColumnSizes,
  RawOptionFeedData,
} from 'types/tape';

const { persistAtom } = recoilPersist();

export const tnsFlowLiveState = atom<boolean>({
  key: 'tns-flowLiveState',
  default: true,
});

export const tnsActiveWatchlistsIdsState = atom<number[]>({
  key: 'tns-activeWatchlistIds',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const tnsActiveScannersState = atom<ScannerID[] | undefined>({
  key: 'tns-activeScannersState',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const tnsNewFilterState = atom<Filter[]>({
  key: 'tns-newFilterState',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const tnsSavedFiltersState = atom<FilterConfig[]>({
  key: 'tns-savedFiltersState',
  default: [],
});

export const tnsActiveCustomFilterState = atom<FilterConfig | undefined>({
  key: 'tns-activeCustomFilterState',
  default: undefined,
  effects_UNSTABLE: [persistAtom],
});

export const tnsColumnsVisibilityState = atom<GridColumnVisibilityModel>({
  key: 'tns-tnsColumnsVisibilityState',
  default: DEFAULT_TAPE_COL_VISIBILITY,
  effects_UNSTABLE: [persistAtom],
});

export const tnsColumnsSortModelState = atom<GridSortModel>({
  key: 'tns-tnsColumnsSortModelState',
  default: [
    {
      field: OptionsFeedColumnKey.Time, // set default sort to descending time by default
      sort: 'desc',
    },
  ],
  effects_UNSTABLE: [persistAtom],
});

export const tnsColumnOrderState = atom<OptionsFeedColumnKey[]>({
  key: 'tns-tnsColumnOrderState',
  default: DEFAULT_TNS_FIELDS,
  effects_UNSTABLE: [persistAtom],
});

export const tnsColumnSizesState = atom<OptionsFeedColumnSizes>({
  key: 'tns-tnsColumnSizesState',
  default: DEFAULT_TAPE_COL_SIZES,
  effects_UNSTABLE: [persistAtom],
});

export const tnsHistDataState = atom<RawOptionFeedData[]>({
  key: 'tns-tnsHistDataState',
  default: [],
});

export const tnsFilterPanelContainerOpenState = atom<boolean>({
  key: 'tns-tnsFilterPanelContainerOpenState',
  default: true,
  effects_UNSTABLE: [persistAtom],
});

export const tnsFilterPanelContainerActiveTab = atom<TapeFilterTab>({
  key: 'tns-tnsFilterPanelContainerActiveTab',
  default: TapeFilterTab.NewFilter,
  effects_UNSTABLE: [persistAtom],
});

export const tnsDailyOverviewExpandedState = atom<boolean>({
  key: 'tns-dailyOverviewExpanded',
  default: true,
  effects_UNSTABLE: [persistAtom],
});

export const tnsFlowSummaryExpandedState = atom<boolean>({
  key: 'tns-flowSummaryExpanded',
  default: true,
  effects_UNSTABLE: [persistAtom],
});

export const tnsDataGridActiveTabState = atom<TapeDatagridTab>({
  key: 'tns-tnsDataGridActiveTab',
  default: TapeDatagridTab.FlowData,
  effects_UNSTABLE: [persistAtom],
});

export const tnsContractsColumnsVisibilityState =
  atom<GridColumnVisibilityModel>({
    key: 'tns-contractsColumnsVisibilityState',
    default: DEFAULT_TAPE_CONTRACTS_COL_VISIBILITY,
    effects_UNSTABLE: [persistAtom],
  });

export const tnsContractsColumnsSortModelState = atom<GridSortModel>({
  key: 'tns-contractsColumnsSortModelState',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const tnsContractsColumnOrderState = atom<OptionsFeedColumnKey[]>({
  key: 'tns-contractsColumnOrderState',
  default: CONTRACT_DATA_COLUMN_KEYS,
  effects_UNSTABLE: [persistAtom],
});

export const tnsContractsColumnSizesState = atom<OptionsFeedColumnSizes>({
  key: 'tns-contractsColumnSizesState',
  default: DEFAULT_TAPE_CONTRACT_COL_SIZES,
  effects_UNSTABLE: [persistAtom],
});
